import { ProjectCollaborationChange } from "features/project-collaboration/types/ProjectCollaborationEvent"

export interface ProjectCollaborationRefreshPlan {
  subtree: boolean
  project: boolean
  price: boolean
  attachments: boolean
}

const FULL_REFRESH: ProjectCollaborationRefreshPlan = {
  subtree: true,
  project: true,
  price: true,
  attachments: true
}

const SUBTREE_TYPES = new Set([
  "floor",
  "room",
  "projectposition",
  "structure",
  "productreference",
  "specialpricegroup",
  "clarificationrequest"
])

const PRICE_TYPES = new Set([
  "project",
  "floor",
  "room",
  "projectposition",
  "structure",
  "specialpricegroup"
])

const KNOWN_TYPES = new Set([
  ...SUBTREE_TYPES,
  ...PRICE_TYPES,
  "project",
  "comment",
  "attachment",
  "sharelink"
])

export function planProjectCollaborationRefresh(
  changes: ProjectCollaborationChange[] | undefined
): ProjectCollaborationRefreshPlan {
  // Publishers that don't send a change list, and entity types this client doesn't know yet,
  // must never be dropped silently.
  if (
    !changes?.length ||
    changes.some(change => !KNOWN_TYPES.has(change.resourceType))
  ) {
    return FULL_REFRESH
  }
  const hasType = (types: Set<string>) =>
    changes.some(change => types.has(change.resourceType))

  return {
    subtree: hasType(SUBTREE_TYPES),
    project: changes.some(change => change.resourceType === "project"),
    price: hasType(PRICE_TYPES),
    attachments: changes.some(change => change.resourceType === "attachment")
  }
}

export function mergeProjectCollaborationRefreshPlans(
  a: ProjectCollaborationRefreshPlan | null,
  b: ProjectCollaborationRefreshPlan
): ProjectCollaborationRefreshPlan {
  if (!a) return b
  return {
    subtree: a.subtree || b.subtree,
    project: a.project || b.project,
    price: a.price || b.price,
    attachments: a.attachments || b.attachments
  }
}
